import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth.js'
import Identity from './modules/identity.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    'auth': Auth,
    'identity': Identity
  },
  state: {
    theme: {
      dark: false
    },
    dialog: {
      id: null,
      title: '',
      visible: false,
      attrs: {},
      component: null,
      componentAttrs: null
    },
    video: {
      visible: false,
      src: null,
      touch: 0
    },
    events: {}
  },
  mutations: {
    setDarkMode(state, isDark) {
      Vue.set(state.theme, 'dark', isDark)
    },
    setActiveDialog (state, { id, title, visible, component, attrs, componentAttrs }) {
      state.dialog = { id, title, visible, component, attrs, componentAttrs }
    },
    setDialogVisible (state, isVisible) {
      Vue.set(state.dialog, 'visible', isVisible)
    },
    setEvent (state, {key, data}) {
      let touch = Math.random()
      Vue.set(state.events, key, {touch, data})
    }
  },
  actions: {
  },
  getters: {
    getEventById: (state) => (id) => {
      if (id in state.events) {
        return state.events[id]
      }
      return {touch: -1, data: null}
    },
    activeDialog (state) {
      return state.dialog
    },
    isDark(state) {
      return state.theme.dark
    }
  }
})
